__turbopack_context__.v({
  "group": "seo-links-module-scss-module__4569Iq__group",
  "link": "seo-links-module-scss-module__4569Iq__link",
  "root": "seo-links-module-scss-module__4569Iq__root",
  "title": "seo-links-module-scss-module__4569Iq__title",
  "toggle": "seo-links-module-scss-module__4569Iq__toggle",
});
